import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useUser } from '../utils/UserContext';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import AddFriend from '../assets/add-friend.png';
import AquaGem from '../assets/aquaGem.png';
import EarnStar from '../assets/earnStar.png';
import axios from 'axios';
import AddFriendA from '../assets/friends.png';


const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: #edf0f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;

`;

const RadialGradient = styled.div`
    position: absolute;
    top: -25%;
    right: -25%;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientA = styled.div`
    position: absolute;
    bottom: -25%;
    left: -25%;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;


const HeroSection = styled.div`
    width: 100%;
    text-align: center;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
`;

const Title = styled.div`
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    font-family: Space Grotesk, Sans Serif;
    color: rgba(0, 0, 0, 0.9);
    margin-top: 15px;
`;

const Subtitle = styled.div`
    font-size: 12px;
    color: rgba(0, 0, 0, 0.75);
    font-weight: 600;
    font-family: Space Grotesk, Sans Serif;
`;

const IconWrapper = styled.div`
    width: 150px;
    height: 150px;
    background: linear-gradient(145deg, rgba(0, 220, 255, 0.2), rgba(0, 220, 255, 0.7));
    box-shadow: 0px 0px 30px rgba(0, 220, 255, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
`;

const GenerateSection = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    z-index: 2;
`;

const StyledButton = styled.button`
    padding: 15px 30px;
    font-size: 1rem;
    font-weight: bold;
    width: 90%;
    border-radius: 50px;
    background: linear-gradient(to bottom right, #007acc, #007acc, #66b2ff); 
    backdrop-filter: blur(10px); // Glass effect
    border: 1px solid #007acc;    
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 20px;
    font-family: Space Grotesk, Sans Serif;

    &:hover {
        transform: scale(1.05);
        box-shadow: 0 0 20px rgba(0, 220, 255, 0.8);
    }
`;

const SubTitleRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: center;
    margin-bottom: 30px;
    `
const GemWrapper = styled.img`
    width: 15px;
    height: 15px;
    object-fit: contain;
    margin: 0px 5px 0px 5px;
    `
const FriendWrapper = styled.img`
    width: 15px;
    height: 15px;
    object-fit: contain;
    margin: 0px 15px 0px 5px;
    `

const StyledButtonA = styled.button`
    padding: 15px 30px;
    font-size: 1rem;
    font-weight: bold;
    width: 90%;
    border-radius: 50px;
    background: #007acc;
    backdrop-filter: blur(10px); // Glass effect
    border: 1px solid rgba(255, 255, 255, 0.2);    
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 20px;
    font-family: Space Grotesk, Sans Serif;

    &:hover {
        transform: scale(1.05);
        box-shadow: 0 0 20px rgba(0, 220, 255, 0.8);
    }
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
`;

const ModalContent = styled.div`
    background: rgba(30, 30, 30, 0.95);
    padding: 20px;
    border-radius: 10px;
    color: white;
    width: 80%;
    max-width: 400px;
    text-align: center;
    box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.3);
`;

const ImageWrapper = {
    position: 'absolute',
    bottom: '0', 
    left: '0',
    width: '100%',
};

const TitleRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '90%',
};

const SectionTitle = {
    fontSize: '18px',
    color: 'rgba(0, 0, 0, 0.75)',
    fontWeight: '600',
    zIndex: '999',
    marginLeft: '10px',
    fontFamily: 'Space Grotesk',
};

const InviteInfo = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '82.5%',
    padding: '20px',
    border: '1px solid rgba(0, 122, 204, 0.5)',
    borderRadius: '15px',
    marginTop: '10px',
    backgroundColor: 'white',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',

};

const IconDiv = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '20px',
    backgroundColor: 'rgba(6, 5, 20, 0.2)',
    borderRadius: '15px',
    height: '100%',
}

const InviteInfoRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
};

const RewardWrapperBigText = {
    fontSize: '14px',
    color: '#e0e0e0',
    fontWeight: '700',
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8)',
};

const ButtonRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
};

const ButtonC = {
    padding: '10px 20px',
    background: 'linear-gradient(to bottom right, #007acc, #007acc, #66b2ff)', 
    borderRadius: '25px',
    border: '2px solid #007acc',
    fontWeight: '700',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    textAlign: 'center',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    marginTop: '20px',
    ':hover': {
        backgroundColor: '#444444',
        transform: 'scale(1.05)',
    },
};

const ButtonTextC = {
    fontSize: '16px',
    color: 'white',
    fontWeight: '600',
    lineHeight: '1.6',
};

const ConceptInvite = () => {
    const { user } = useUser();
    const [userInviteLink, setUserInviteLink] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    const teamSize = userData && userData.team;
    const teamRewards = userData && userData.team_rewards;

    const handleGenerateLink = () => {
        const botUsername = "HydrixGemsBot";
        const inviteLink = `https://t.me/${botUsername}?start=${user.id}`;
        navigator.clipboard.writeText(inviteLink).then(() => {
            setUserInviteLink(inviteLink);
            setModalOpen(true);
        });
    };

    const fetchUserData = async () => {
        try {
            const response = await axios.get(`https://chainfree.info:5000/user`);
            setUserData(response.data.userData);
            console.log('userData', response.data.userData);
            setError(null); 
        } catch (error) {
            setError(error.message);
        }
    };

    useEffect(() => {
        fetchUserData();
      }, []); 

    return (
        <Container>
            <HeroSection>
                <Title>Invite Your Friends</Title>
                <SubTitleRow>
                    <Subtitle>Earn</Subtitle>
                        <GemWrapper src={AquaGem} />
                    <Subtitle>For inviting friends & family!</Subtitle>
                </SubTitleRow>
                
            <div style={TitleRow}>
                <img src={EarnStar} />
                <div style={SectionTitle}>Rewards</div>
            </div>
            <div style={InviteInfo}>
                <div style={IconDiv}></div>
                <div style={InviteInfoRow}>
                    <FriendWrapper src={AddFriendA} />
                    <div style={RewardWrapperBigText}>You have invited {userData && teamSize != null ? teamSize.toFixed(0) : "?"} friend(s)! </div>
                </div>
                <div style={{ ...InviteInfoRow, marginTop: '20px' }}>
                    <FriendWrapper src={AquaGem} />
                    <div style={RewardWrapperBigText}>You have earnt {userData && teamRewards != null ? teamRewards.toFixed(0) : "?"} Aqua Gems!</div>
                </div>
                <div style={ButtonRow}>
                <Link to="/earn">
                    <button style={ButtonC}>
                        <div style={ButtonTextC}>Extra Rewards</div>
                    </button>
                </Link>
                </div>
            </div>         
            </HeroSection>
            <GenerateSection>
                <StyledButton onClick={handleGenerateLink}>Copy Invite Link</StyledButton>
                
            </GenerateSection>
            
            {isModalOpen && (
                <ModalOverlay onClick={() => setModalOpen(false)}>
                    <ModalContent>
                        <p>Your invite link has been copied to the clipboard!</p>
                        <p>
                            <a href={userInviteLink} target="_blank" rel="noopener noreferrer">
                                {userInviteLink}
                            </a>
                        </p>
                    </ModalContent>
                </ModalOverlay>
            )}
            <Footer />
        </Container>
    );
};

export default ConceptInvite;
